
// // src/pages/treatments/LiposuctionTummyTuckPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart, Sparkles } from "lucide-react";

// const LIPO_TREATMENT = {
//   slug: "liposuction-tummy-tuck",
//   name: "Liposuction with Tummy Tuck",
//   shortName: "Body Contouring",
//   tagline: "Sculpt Your Dream Silhouette",
//   heroSubtag: "Save 60–75% on body contouring. World-class cosmetic surgeons. No waiting list.",
//   description:
//     "Comprehensive body contouring combining liposuction and abdominoplasty (tummy tuck) to remove stubborn fat deposits and tighten abdominal muscles. Our board-certified plastic surgeons use advanced techniques including VASER, SmartLipo, and high-definition liposculpture for natural-looking results with minimal scarring.",
//   heroImage: "/TummyTuck.jpeg", 
//   category: "Cosmetic Surgery",
//   badge: "Transformative",
//   accentColor: "pink",
//   costCard: {
//     label: "Complete body contouring package",
//     value: "₹1.8L–₹3.5L",
//     compare: "vs. ₹25L+ in the UK",
//     stay: "2–4 days hospital + 10–14 days recovery",
//     stayCompare: "vs. $15,000–$25,000 in the US",
//   },
//   stats: [
//     { label: "Success Rate", value: "98%", icon: Award },
//     { label: "Procedures/Year", value: "2,500+", icon: Users },
//     { label: "Years Experience", value: "20+", icon: Shield },
//     { label: "Recovery Time", value: "2 Weeks", icon: Clock },
//   ],
//   benefits: [
//     "Combined liposuction + tummy tuck for comprehensive results",
//     "Advanced VASER & SmartLipo technologies for precise fat removal",
//     "Muscle repair for diastasis recti (post-pregnancy)",
//     "Hidden incision techniques for minimal visible scarring",
//     "Board-certified plastic surgeons with international training",
//     "Customised treatment plans for individual body types",
//     "Complimentary post-operative compression garments",
//     "Telemedicine follow-up for international patients",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Consultation & Planning",
//       desc: "3D body imaging, medical evaluation, and personalised surgical plan.",
//       duration: "1-2 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Pre-Op Preparation",
//       desc: "Lab tests, medical clearance, and pre-operative marking.",
//       duration: "1-2 Days",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Surgery Day",
//       desc: "Liposuction of targeted areas followed by tummy tuck with muscle repair if needed.",
//       duration: "3-5 Hours",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Recovery & Results",
//       desc: "Compression garments, drainage management, and gradual return to activities.",
//       duration: "2-6 Weeks",
//       icon: Sparkles,
//     },
//   ],
//   faqs: [
//     {
//       q: "Can liposuction and tummy tuck be done together?",
//       a: "Yes. Combining both procedures in a single surgery (often called a 'mommy makeover' component) reduces overall recovery time and cost while providing comprehensive results. Your surgeon will assess if you're a good candidate.",
//     },
//     {
//       q: "Who is an ideal candidate for this procedure?",
//       a: "Ideal candidates are near their target weight with stubborn fat deposits and loose abdominal skin — often after pregnancy or significant weight loss. Stable weight for 6+ months and good overall health are recommended.",
//     },
//     {
//       q: "What is the recovery like?",
//       a: "Most patients return to light activities within 2 weeks and full activities within 6 weeks. Compression garments are worn for 4-6 weeks. Swelling subsides gradually, with final results visible at 3-6 months.",
//     },
//     {
//       q: "Will there be visible scars?",
//       a: "Your surgeon places incisions strategically — typically low on the abdomen (bikini line) and around the belly button. Scars fade significantly over 12-18 months and are easily concealed under underwear or swimwear.",
//     },
//     {
//       q: "When can I see the final results?",
//       a: "Initial results are visible immediately, but final results develop over 3-6 months as swelling resolves and tissues settle. Most patients are delighted with their transformation at the 6-month mark.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Sunil Choudhary",
//       specialty: "Plastic & Cosmetic Surgeon",
//       experience: "25 Years",
//       rating: 4.9,
//       reviews: 2900,
//       image: "https://randomuser.me/api/portraits/men/31.jpg",
//       qualifications: "MBBS, MS, MCh (Plastic Surgery)",
//       hospital: "Artemis Hospital, Gurugram",
//     },
//     {
//       name: "Dr. Geeta Nair",
//       specialty: "Cosmetic & Reconstructive Surgeon",
//       experience: "18 Years",
//       rating: 4.8,
//       reviews: 2100,
//       image: "https://randomuser.me/api/portraits/women/41.jpg",
//       qualifications: "MBBS, MS, DNB (Plastic Surgery)",
//       hospital: "Apollo Hospitals, Chennai",
//     },
//     {
//       name: "Dr. Rohan Mehta",
//       specialty: "Body Contouring Specialist",
//       experience: "15 Years",
//       rating: 4.8,
//       reviews: 1850,
//       image: "https://randomuser.me/api/portraits/men/51.jpg",
//       qualifications: "MBBS, MS, Fellowship in Aesthetic Surgery",
//       hospital: "Fortis Hospital, Mumbai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Priya Sharma",
//       age: 34,
//       location: "Delhi",
//       text: "After two kids, I had given up on my pre-pregnancy body. The combined liposuction and tummy tuck gave me my confidence back. The surgeon was incredibly skilled and the care team was wonderful.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/61.jpg",
//       treatment: "Liposuction + Tummy Tuck",
//       date: "January 2024",
//     },
//     {
//       name: "Ananya Patel",
//       age: 42,
//       location: "Ahmedabad",
//       text: "I lost 40kg through diet and exercise but was left with loose skin and stubborn fat. This procedure was life-changing. The results are natural and the scarring is minimal — exactly what I wanted.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/72.jpg",
//       treatment: "Post-Weight Loss Body Contouring",
//       date: "March 2024",
//     },
//     {
//       name: "Neha Kapoor",
//       age: 29,
//       location: "Mumbai",
//       text: "I always struggled with my belly pooch despite being fit. The VASER liposuction with skin tightening was a game-changer. Back to my yoga classes in 3 weeks!",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/82.jpg",
//       treatment: "VASER Liposuction + Skin Tightening",
//       date: "November 2023",
//     },
//   ],
// };

// const LIPO_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why International Patients Choose India for Cosmetic Surgery",
//   whyIndiaReasons: [
//     "World-class plastic surgeons trained at American & European centres",
//     "NABH & JCI accredited hospitals with state-of-the-art facilities",
//     "Cost savings of 60–75% compared to Western countries",
//     "No waiting lists — surgery within 7–10 days of arrival",
//   ],
//   conditionsTitle: "Body Contouring Procedures We Facilitate",
//   conditions: [
//     "Liposuction (VASER, SmartLipo, Tumescent)",
//     "Abdominoplasty (Tummy Tuck)",
//     "Mommy Makeover (Combined Procedures)",
//     "High-Definition Liposculpture",
//     "Post-Weight Loss Body Contouring",
//     "Arm Lift (Brachioplasty)",
//     "Thigh Lift",
//     "Body Lift",
//   ],
//   stayValue: "2–4 days hospital + 10–14 days recovery (28 total days for best results)",
//   costTitle: "Why India for Body Contouring?",
//   costRows: [
//     {
//       procedure: "Liposuction (3 areas)",
//       india: "₹80K – ₹1.5L",
//       africa: "$5,000–$8,000",
//       ukusa: "$8,000–$15,000",
//     },
//     {
//       procedure: "Tummy Tuck (Full Abdominoplasty)",
//       india: "₹1.2L – ₹2.5L",
//       africa: "$7,000–$12,000",
//       ukusa: "$12,000–$20,000",
//     },
//     {
//       procedure: "Liposuction + Tummy Tuck Combo",
//       india: "₹1.8L – ₹3.5L",
//       africa: "$10,000–$18,000",
//       ukusa: "$18,000–$30,000",
//     },
//   ],
// };

// const LiposuctionTummyTuckPage = () => {
//   return <TreatmentTemplate treatment={LIPO_TREATMENT} paxgrowData={LIPO_PAXGROW} />;
// };

// export default LiposuctionTummyTuckPage;

// src/pages/treatments/LiposuctionTummyTuckPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart, Sparkles } from "lucide-react";

const LIPO_TREATMENT = {
  slug: "liposuction-tummy-tuck",
  name: "Liposuction with Tummy Tuck",
  shortName: "Body Contouring",
  tagline: "Sculpt Your Dream Silhouette",
  heroSubtag: "Save 60–75% on body contouring. World-class cosmetic surgeons. No waiting list.",
  description:
    "Comprehensive body contouring combining liposuction and abdominoplasty (tummy tuck) to remove stubborn fat deposits and tighten abdominal muscles. Our board-certified plastic surgeons use advanced techniques including VASER, SmartLipo, and high-definition liposculpture for natural-looking results with minimal scarring.",
  heroImage: "/TummyTuck.jpeg",
  category: "Cosmetic Surgery",
  badge: "Transformative",
  accentColor: "pink",
  costCard: {
    label: "Complete body contouring package",
    value: "$2,200–$4,200",
    compare: "vs. $30,000+ in the UK",
    stay: "2–4 days hospital + 10–14 days recovery",
    stayCompare: "vs. $15,000–$25,000 in the US",
  },
  stats: [
    { label: "Success Rate", value: "98%", icon: Award },
    { label: "Procedures/Year", value: "2,500+", icon: Users },
    { label: "Years Experience", value: "20+", icon: Shield },
    { label: "Recovery Time", value: "2 Weeks", icon: Clock },
  ],
  benefits: [
    "Combined liposuction + tummy tuck for comprehensive results",
    "Advanced VASER & SmartLipo technologies for precise fat removal",
    "Muscle repair for diastasis recti (post-pregnancy)",
    "Hidden incision techniques for minimal visible scarring",
    "Board-certified plastic surgeons with international training",
    "Customised treatment plans for individual body types",
    "Complimentary post-operative compression garments",
    "Telemedicine follow-up for international patients",
  ],
  procedure: [
    {
      step: "01",
      title: "Consultation & Planning",
      desc: "3D body imaging, medical evaluation, and personalised surgical plan.",
      duration: "1-2 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Pre-Op Preparation",
      desc: "Lab tests, medical clearance, and pre-operative marking.",
      duration: "1-2 Days",
      icon: Activity,
    },
    {
      step: "03",
      title: "Surgery Day",
      desc: "Liposuction of targeted areas followed by tummy tuck with muscle repair if needed.",
      duration: "3-5 Hours",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Recovery & Results",
      desc: "Compression garments, drainage management, and gradual return to activities.",
      duration: "2-6 Weeks",
      icon: Sparkles,
    },
  ],
  faqs: [
    {
      q: "Can liposuction and tummy tuck be done together?",
      a: "Yes. Combining both procedures in a single surgery (often called a 'mommy makeover' component) reduces overall recovery time and cost while providing comprehensive results. Your surgeon will assess if you're a good candidate.",
    },
    {
      q: "Who is an ideal candidate for this procedure?",
      a: "Ideal candidates are near their target weight with stubborn fat deposits and loose abdominal skin — often after pregnancy or significant weight loss. Stable weight for 6+ months and good overall health are recommended.",
    },
    {
      q: "What is the recovery like?",
      a: "Most patients return to light activities within 2 weeks and full activities within 6 weeks. Compression garments are worn for 4-6 weeks. Swelling subsides gradually, with final results visible at 3-6 months.",
    },
    {
      q: "Will there be visible scars?",
      a: "Your surgeon places incisions strategically — typically low on the abdomen (bikini line) and around the belly button. Scars fade significantly over 12-18 months and are easily concealed under underwear or swimwear.",
    },
    {
      q: "When can I see the final results?",
      a: "Initial results are visible immediately, but final results develop over 3-6 months as swelling resolves and tissues settle. Most patients are delighted with their transformation at the 6-month mark.",
    },
  ],
  doctors: [
    {
      name: "Dr. Sunil Choudhary",
      specialty: "Plastic & Cosmetic Surgeon",
      experience: "25 Years",
      rating: 4.9,
      reviews: 2900,
      image: "https://randomuser.me/api/portraits/men/31.jpg",
      qualifications: "MBBS, MS, MCh (Plastic Surgery)",
      hospital: "Artemis Hospital, Gurugram",
    },
    {
      name: "Dr. Geeta Nair",
      specialty: "Cosmetic & Reconstructive Surgeon",
      experience: "18 Years",
      rating: 4.8,
      reviews: 2100,
      image: "https://randomuser.me/api/portraits/women/41.jpg",
      qualifications: "MBBS, MS, DNB (Plastic Surgery)",
      hospital: "Apollo Hospitals, Chennai",
    },
    {
      name: "Dr. Rohan Mehta",
      specialty: "Body Contouring Specialist",
      experience: "15 Years",
      rating: 4.8,
      reviews: 1850,
      image: "https://randomuser.me/api/portraits/men/51.jpg",
      qualifications: "MBBS, MS, Fellowship in Aesthetic Surgery",
      hospital: "Fortis Hospital, Mumbai",
    },
  ],
  testimonials: [
    {
      name: "Priya Sharma",
      age: 34,
      location: "Delhi",
      text: "After two kids, I had given up on my pre-pregnancy body. The combined liposuction and tummy tuck gave me my confidence back. The surgeon was incredibly skilled and the care team was wonderful.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/61.jpg",
      treatment: "Liposuction + Tummy Tuck",
      date: "January 2024",
    },
    {
      name: "Ananya Patel",
      age: 42,
      location: "Ahmedabad",
      text: "I lost 40kg through diet and exercise but was left with loose skin and stubborn fat. This procedure was life-changing. The results are natural and the scarring is minimal — exactly what I wanted.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/72.jpg",
      treatment: "Post-Weight Loss Body Contouring",
      date: "March 2024",
    },
    {
      name: "Neha Kapoor",
      age: 29,
      location: "Mumbai",
      text: "I always struggled with my belly pooch despite being fit. The VASER liposuction with skin tightening was a game-changer. Back to my yoga classes in 3 weeks!",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/82.jpg",
      treatment: "VASER Liposuction + Skin Tightening",
      date: "November 2023",
    },
  ],
};

const LIPO_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why International Patients Choose India for Cosmetic Surgery",
  whyIndiaReasons: [
    "World-class plastic surgeons trained at American & European centres",
    "NABH & JCI accredited hospitals with state-of-the-art facilities",
    "Cost savings of 60–75% compared to Western countries",
    "No waiting lists — surgery within 7–10 days of arrival",
  ],
  conditionsTitle: "Body Contouring Procedures We Facilitate",
  conditions: [
    "Liposuction (VASER, SmartLipo, Tumescent)",
    "Abdominoplasty (Tummy Tuck)",
    "Mommy Makeover (Combined Procedures)",
    "High-Definition Liposculpture",
    "Post-Weight Loss Body Contouring",
    "Arm Lift (Brachioplasty)",
    "Thigh Lift",
    "Body Lift",
  ],
  stayValue: "2–4 days hospital + 10–14 days recovery (28 total days for best results)",
  costTitle: "Why India for Body Contouring?",
  costRows: [
    {
      procedure: "Liposuction (3 areas)",
      india: "$1,000–$1,800",
      africa: "$5,000–$8,000",
      ukusa: "$8,000–$15,000",
    },
    {
      procedure: "Tummy Tuck (Full Abdominoplasty)",
      india: "$1,500–$3,000",
      africa: "$7,000–$12,000",
      ukusa: "$12,000–$20,000",
    },
    {
      procedure: "Liposuction + Tummy Tuck Combo",
      india: "$2,200–$4,200",
      africa: "$10,000–$18,000",
      ukusa: "$18,000–$30,000",
    },
  ],
};

const LiposuctionTummyTuckPage = () => {
  return <TreatmentTemplate treatment={LIPO_TREATMENT} paxgrowData={LIPO_PAXGROW} />;
};

export default LiposuctionTummyTuckPage;